export const ECTO_WATER_PETROHUE = '/Petrohue';
